
import Datetime from 'vux/src/components/datetime/index.vue'
import Countup from 'vux/src/components/countup/index.vue'

import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import VAxis from 'vux/src/components/v-chart/v-axis.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'


export default {
components: {
Datetime,
Countup,
VChart,
VAxis,
VLine,
VScale,
VTooltip
},
data() {
return {
dateStatus:false,
index:0,
orderCount:0,
collectCount:0,
startDate:'',
endDate:'',
data: [
{
date:'2021-04-15',value:0,'type':'下单',
date:'2021-04-16',value:0,'type':'下单',
date:'2021-04-17',value:0,'type':'下单',
date:'2021-04-18',value:0,'type':'下单',
date:'2021-04-15',value:0,'type':'收衣',
date:'2021-04-16',value:0,'type':'收衣',
date:'2021-04-17',value:0,'type':'收衣',
date:'2021-04-18',value:0,'type':'收衣',
}
]
}
},
created(){
this.setDate();
this.getData();
},
methods: {
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
var date = new Date(this.endDate);
console.log(date);
nowDate.setMonth(nowDate.getMonth()-1);
var date1 = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}
},
getData() {
this.$api.communityData({startDate:this.startDate,endDate:this.endDate,type:0}).then((res)=>{
if(res){
this.data = res.data.list;
this.collectCount = res.data.collectCount;
this.orderCount = res.data.orderCount;
this.$refs.echart.rerender();
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/communityData.vue